export const TABLE_THEME = {
  actionButton: 'text-slate-500 hover:border-sky-200 hover:bg-sky-50 hover:text-sky-600',
  actionMenuButton: 'text-slate-700 hover:bg-slate-100',
  actionLoading: 'text-main',
  toolbar: 'border-gray-200 bg-white',
  toolbarDivider: 'bg-slate-200',
  root: 'bg-white',
  surface: 'bg-white',
  surfaceBorder: 'border-gray-200',
  tableText: 'text-black',
  header: 'bg-[#f3f3f3]',
  headerBorder: 'border-[#ddd]',
  separator: 'bg-[#ddd]',
  headerText: 'text-black',
  headerIndexText: 'text-gray-400',
  bodyBorder: 'border-[#ddd]',
  bodyIndexText: 'text-gray-400',
  inputBodyIndexText: 'text-slate-500',
  loadingBorder: 'border-slate-100',
  loadingPlaceholder: 'bg-slate-200',
  inputLoadingPlaceholder: 'bg-slate-100',
  inputHeaderCell: '[&_thead_th]:border-[#ddd] [&_thead_th]:bg-[#f3f3f3]',
  inputBodyCell: '[&_tbody_td]:border-[#ddd]',
  inputSelectedCell: '[&_td.selected-cell]:!border-[rgba(2,62,138,0.9)] [&_td.selected-cell]:!bg-[rgba(2,62,138,0.15)]',
  empty: 'bg-white text-slate-500',
  pagination: 'border-slate-200 text-slate-500',
  rowSelected: 'bg-[#ffff99]',
  rowEven: 'bg-white hover:bg-[#ffff99]',
  rowOdd: 'bg-[#fafafa] hover:bg-[#ffff99]',
  stickyEven: 'bg-white group-hover:bg-[#ffff99]',
  stickyOdd: 'bg-[#fafafa] group-hover:bg-[#ffff99]',
  resizeHandleHover: 'hover:after:bg-[#1976d2]',
  resizeHandleActive: 'after:bg-[#1976d2]',
  scrollbar: '[&::-webkit-scrollbar-thumb]:bg-[#bdbdbd] [&::-webkit-scrollbar-track]:bg-[#f5f5f5]'
} as const;
